import { useEffect, useRef } from 'react';
import { readActiveTenantId } from '@/shared/lib/tenantSession';
import { useMyTenantsQuery, useSwitchTenant } from '../api/queries';
import { useSession } from './sessionContext';

/**
 * Il tenant attivo della sessione e quelli disponibili. Con un solo tenant e
 * nessuno attivo lo seleziona da solo, una volta.
 */
export function useTenantSession() {
  const { user } = useSession();
  const activeTenantId = readActiveTenantId();
  const tenantsQuery = useMyTenantsQuery(user?._id);
  const switchMutation = useSwitchTenant();
  const autoSwitchAttempted = useRef(false);
  const autoSwitching = useRef(false);

  const availableTenants = tenantsQuery.data ?? [];
  const { mutate } = switchMutation;

  useEffect(() => {
    const [onlyTenant, ...others] = tenantsQuery.data ?? [];
    if (activeTenantId || autoSwitchAttempted.current || !onlyTenant || others.length > 0) return;
    autoSwitchAttempted.current = true;
    autoSwitching.current = true;
    mutate(onlyTenant._id);
  }, [activeTenantId, tenantsQuery.data, mutate]);

  const switchTenant = (tenantId: string) => {
    if (!tenantId || tenantId === activeTenantId) return;
    autoSwitching.current = false;
    mutate(tenantId);
  };

  return {
    activeTenantId,
    activeTenant: availableTenants.find((tenant) => tenant._id === activeTenantId) ?? null,
    availableTenants,
    needsTenantSelection: Boolean(user) && !activeTenantId,
    tenantsLoading: tenantsQuery.isFetching,
    autoSwitching: switchMutation.isPending && autoSwitching.current,
    error: (switchMutation.error ?? tenantsQuery.error)?.message ?? '',
    switchTenant,
  };
}
